module.exports = __webpack_public_path__ + "static/media/sin-trafico-logo.b7190dfe.svg";